import * as React from "react";
import { ReactSVG } from "react-svg";
import restar from "../assets/restar.svg";
import sumar from "../assets/sumar.svg";
import { createBrowserHistory } from "history";
import urlServer from '../server'
import { validarVencimientoToken } from "../localStorageManager";

export default class CargarPedidoDiario extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.props.props,
            misPedidos: [],
        };
    }

    history = createBrowserHistory();

    // funciones input inicio
    definirBackGround = (dia) => {
        if (dia.cantidad === false) {
            return "hsla(14, 100%, 53%, 0.6)";
        } else {
            return "white";
        }
    };

    componentWillMount = async () => {
        let misPedidos = await this.obtenerMisPedidos();
        let pedidosFiltrados = this.verificarEdicionesPedidas(misPedidos)
        this.setState({ misPedidos: pedidosFiltrados });
    }

    handleInputOnBlurPedidoConDias = (e, dia, edicionesDiario, index) => {
        let nroElementosCarrito = this.state.nroElementosCarrito;

        let regex = /[^0-9]/g;
        // Limpiar caracteres no numéricos
        if (regex.test(e.target.value)) {
            e.target.value = e.target.value.replace(regex, "");
        }

        if (e.target.value === "") {
            dia.cantidad = 0;

            if (dia.cantidad !== dia.cantidadBackup) {
                nroElementosCarrito =
                    (dia.cantidad === 0 || dia.cantidad === null) && dia.cantidadBackup > 0
                        ? this.state.nroElementosCarrito - 1
                        : dia.cantidad > 0 &&
                            (dia.cantidadBackup === 0 || dia.cantidadBackup === null)
                            ? this.state.nroElementosCarrito + 1
                            : this.state.nroElementosCarrito;

                dia.cantidadBackup = 0;
                this.props.actualizarCarrito(null, dia.cantidad, dia.DiaSemana);
            }

            edicionesDiario[index] = dia;
            this.setState({
                edicionesDiario,
                nroElementosCarrito,
            });
        } else {
            nroElementosCarrito =
                (dia.cantidad === 0 || dia.cantidad === null) && dia.cantidadBackup > 0
                    ? this.state.nroElementosCarrito - 1
                    : dia.cantidad > 0 && (dia.cantidadBackup === 0 || dia.cantidadBackup === null)
                        ? this.state.nroElementosCarrito + 1
                        : this.state.nroElementosCarrito;

            e.target.value =
                e.target.value === "0" ? e.target.value : e.target.value.replace(/^(0+)/g, "");
            dia.cantidad =
                e.target.value === "" || e.target.value < 0 ? null : parseInt(e.target.value);

            if (dia.cantidad !== dia.cantidadBackup) {
                dia.cantidadBackup = dia.cantidad;
                this.props.actualizarCarrito(null, dia.cantidad, dia.DiaSemana);
                edicionesDiario[index] = dia;

                this.setState({
                    edicionesDiario,
                    nroElementosCarrito,
                });
            }
        }
        this.props.mostrarNroElementoCar(nroElementosCarrito);
    };

    obtenerMisPedidos = async () => {
        const headers = {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: 'Bearer ' + localStorage.token,
        }

        var initPedidos = {
            "fechaDesde": new Date((new Date()).setDate((new Date()).getDate() - 29)).toISOString().slice(0, 10),
            "fechaHasta": new Date().toISOString().slice(0, 10),
            "puntoVentaId": JSON.parse(localStorage.infoToken).entidad_id,
            "productoId": null,
            "edicionId": null,
            "nombreTienda": null
        };

        const respuesta = await fetch(urlServer + '/api/pedidopasadofuturo/Buscar', {
            method: 'POST',
            redirect: 'manual',
            body: JSON.stringify(initPedidos),
            headers
        }).then(response => response.text())
            .catch(error => {
                console.log('error', error);
                this.setState({
                    loading: false
                })
            })
            .then(result => {

                const res = JSON.parse(result)
                validarVencimientoToken(res.message);
                this.setState({
                    pedidos: res,
                    loading: false
                })
                return res
            })
            .catch(error => {
                console.log('error', error);
                validarVencimientoToken(error.message);

                this.setState({
                    loading: false
                })
            })

        return respuesta;
    }

    verificarEdicionesPedidas = (misPedidos) => {
        let producto = this.state.producto;
        let diasSemana = this.state.diasSemana;

        let diasArray = [{ numDia: 1, descripcion: "DO" },
        { numDia: 2, descripcion: "LU" },
        { numDia: 3, descripcion: "MA" },
        { numDia: 4, descripcion: "MI" },
        { numDia: 5, descripcion: "JU" },
        { numDia: 6, descripcion: "VI" },
        { numDia: 7, descripcion: "SA" }];

        let filtrados = misPedidos.filter(pedido => {
            let prefijo = pedido.edicion.slice(0, 2).toUpperCase(); //Quita las dos primeras letras de la edicion (LU,MA, etc)
            if (pedido.publicacion.includes(producto.descripcion)
                && diasArray.some(dia => dia.descripcion === prefijo)
                && pedido.estadoId == 1) {//Solicitado
                let diaNumero = diasArray.find(dia => dia.descripcion === prefijo).numDia; //Guardo el num del dia para poder usarlo en el render
                diasSemana.find(dia => {
                    if (dia.DiaSemana === diaNumero) {
                        dia.yaPedido = true;
                        dia.cantidad = pedido.cantidadPedida;
                    }
                }

                )
                return true
            } else { return false }
        });
        this.setState({ diasSemana: diasSemana })
        return filtrados;
    }

    handleOnClickPedidoDiarioInput = (dia, index) => {
        let nroElementosCarrito = this.state.nroElementosCarrito;

        if (dia.cantidad > 0) {
            let { edicionesDiario } = this.state;
            edicionesDiario[index].cantidad--;
            edicionesDiario[index].cantidadBackup--;
            let elemento = document.getElementById(
                `dia-${dia.DiaSemana}`
            );

            if (elemento) {
                elemento.value = dia.cantidad;
            }

            this.props.actualizarCarrito(null, dia.cantidad, dia.DiaSemana, 1);

            var nroElementosCarritoTemp =
                dia.cantidad === 0
                    ? nroElementosCarrito - 1
                    : nroElementosCarrito;

            this.setState({
                edicionesDiario,
                nroElementosCarrito: nroElementosCarritoTemp,
            });

            this.props.mostrarNroElementoCar(
                nroElementosCarritoTemp
            );
        }
    };

    handleOnChangePedidoDiarioInput = (e, dia, edicionesDiario, index) => {
        let regex = /[^0-9]/g;
        if (regex.test(e.target.value)) {
            e.target.value = e.target.value.replace(regex, "");
        }

        e.target.value =
            e.target.value === "0" ? e.target.value : e.target.value.replace(/^(0+)/g, "");

        dia.cantidad =
            e.target.value === "" || e.target.value < 0 ? false : parseInt(e.target.value);

        edicionesDiario[index].cantidad = dia.cantidad;

        this.setState({
            edicionesDiario,
        });
    };
    // funciones input fin

    handleOnClickPedidoDiarioSumar = (dia, index) => {
        let { edicionesDiario, nroElementosCarrito } = this.state;
        edicionesDiario[index].cantidad++;
        edicionesDiario[index].cantidadBackup++;

        let elemento = document.getElementById(
            `dia-${dia.DiaSemana}`
        );

        if (elemento) {
            elemento.value = dia.cantidad;
        }

        this.props.actualizarCarrito(
            null,
            dia.cantidad,
            dia.DiaSemana,
            1
        );

        var nroElementosCarritoTemp =
            dia.cantidad === 1
                ? nroElementosCarrito + 1
                : nroElementosCarrito;

        this.setState({
            edicionesDiario,
            nroElementosCarrito: nroElementosCarritoTemp,
        });

        this.props.mostrarNroElementoCar(nroElementosCarritoTemp);
    }

    render() {
        const { edicionesDiario, diasSemana } = this.state;
        return (
            <React.Fragment>
                <div className="pedido" style={{ paddingBottom: "95px" }}>
                    <div className="f-16 fw-400 text-center" style={{ marginBottom: "30px" }}>
                        Pedido futuro
                    </div>
                    {edicionesDiario?.map((dia, index) => {
                        return (
                            <div
                                key={index}
                                className="d-flex justify-content-between align-items-center days"
                            >
                                <div
                                    className="f-13-5 fw-400"
                                    style={{
                                        color: "#343435",
                                        maxWidth: "66%",
                                    }}
                                >
                                    {dia.dia}
                                </div>
                                {/*CONTENEDOR*/}
                                <div
                                    className="d-flex justify-content-between align-items-center"
                                    style={{ width: "88px" }}
                                >
                                    {/*RESTAR*/}
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            cursor: diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido ? "" : "pointer",
                                            background: diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido || dia.cantidad === 0 ? "#FCFCFC" : "#F4F4F4",
                                            width: "26px",
                                            height: "26px",
                                            borderRadius: "50%",
                                        }}
                                        onClick={() => {
                                            if (diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido) {
                                                this.props.mostrarAvisoYaPedido()
                                            } else {
                                                this.handleOnClickPedidoDiarioInput(dia, index)
                                            }
                                        }}
                                    >
                                        <ReactSVG
                                            src={restar}
                                            style={{
                                                color: (diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido) || dia.cantidad === 0 ? "#EAEAEA" : "#8E95A5",
                                                width: "11px",
                                            }}
                                        />
                                    </div>
                                    {/*INPUT*/}
                                    <div className="f-13-5">
                                        <input
                                            style={{
                                                backgroundColor: (diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido)
                                                    ? "#F4F4F4" : this.definirBackGround(dia),
                                                border: (diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido)
                                                    ? "#F4F4F4 solid 1px" : "#343435 solid 1px",
                                                color: (diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido)
                                                    ? "#888" : "#000",
                                            }}
                                            type="number"
                                            autoComplete="off"
                                            className="input-of-cantidades text-center"
                                            maxLength="3"
                                            id={`dia-${dia.DiaSemana}`}
                                            value={
                                                diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido
                                                    ? diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.cantidad
                                                    : dia.cantidad
                                            }
                                            disabled={diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido}
                                            onFocus={(e) => {
                                                e.target.select();
                                            }}
                                            min={"0"}
                                            max={"100000"}
                                            onInput={(e) => (e.target.value = e.target.value.slice(0, 6))}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.currentTarget.blur();
                                                }
                                            }}
                                            onClick={(e) => {
                                                if (diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido) {
                                                    this.props.mostrarAvisoYaPedido();
                                                }
                                            }}
                                            onChange={(e) => {
                                                if (diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido) {
                                                    this.props.mostrarAvisoYaPedido();
                                                } else {
                                                    this.handleOnChangePedidoDiarioInput(e, dia, edicionesDiario, index);
                                                }
                                            }}
                                            onBlur={(e) => {
                                                if (!diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido) {
                                                    this.handleInputOnBlurPedidoConDias(e, dia, edicionesDiario);
                                                }
                                            }}
                                        />
                                    </div>
                                    {/*SUMAR*/}
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            cursor: diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido ? "" : "pointer",
                                            background:
                                                dia.cantidad === 100000 ? "#FCFCFC" : "#F4F4F4",
                                            width: "26px",
                                            height: "26px",
                                            borderRadius: "50%",
                                            pointerEvents: dia.cantidad >= 100000 ? "none" : "",
                                        }}
                                        onClick={() => {
                                            if (diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido) {
                                                this.props.mostrarAvisoYaPedido()
                                            }
                                            else { this.handleOnClickPedidoDiarioSumar(dia, index) }
                                        }}
                                    >
                                        <ReactSVG
                                            src={sumar}
                                            style={{
                                                width: "11px",
                                                height: "18px",
                                                color: diasSemana.find(ds => ds.DiaSemana === dia.DiaSemana)?.yaPedido ? '#EAEAEA' : '#8E95A5',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </React.Fragment>
        );
    }
}
